import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import SearchInput from './SearchInput';

const navItems = [
  { label: '首页', to: '/' },
  { label: '黄金行情', to: '/category/gold-price' },
  { label: '投资资讯', to: '/category/investment-news' },
  { label: '关于我们', to: '/about' },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="border-b border-background-200 bg-secondary-900">
        <div className="mx-auto flex max-w-portal items-center justify-between px-4 py-1.5 text-xs text-secondary-100 md:px-6">
          <span className="flex items-center gap-2">
            <i className="ri-calendar-line" aria-hidden="true"></i>
            2026年10月12日 星期一
          </span>
          <span className="hidden items-center gap-4 sm:flex">
            <span className="flex items-center gap-1.5">
              <i className="ri-information-line" aria-hidden="true"></i>
              行情与图表为演示数据
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-mail-line" aria-hidden="true"></i>
              service@gold.example.com
            </span>
          </span>
        </div>
      </div>

      <div className="mx-auto flex max-w-portal items-center justify-between gap-4 px-4 py-3 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-primary-400 to-accent-600 font-heading text-lg font-black text-foreground-950">
            金
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-bold tracking-wide text-foreground-950">黄金</span>
            <span className="mt-0.5 text-[10px] font-medium uppercase tracking-[0.2em] text-primary-700">
              Gold Market
            </span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-md px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap ${
                  isActive
                    ? 'bg-primary-100 text-primary-800'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-primary-700'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden w-full max-w-xs flex-1 lg:block">
          <SearchInput size="sm" />
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:bg-background-100 lg:hidden cursor-pointer"
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true"></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-4 lg:hidden">
          <SearchInput size="sm" className="mb-4" onSearched={() => setMenuOpen(false)} />
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `rounded-md px-4 py-3 text-sm font-medium transition-colors ${
                    isActive ? 'bg-primary-100 text-primary-800' : 'text-foreground-700 hover:bg-background-100'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}